<template>
    <span v-if="resultsArray.length" class="chat__message-bubble">
        <span class="player-message player-message--dices">
            <template v-for="(result, index) in resultsArray">
                <span class="icon filled">
                        <svg>
                            <use :xlink:href="generateSvgIcon(index)"></use>
                        </svg>
                </span><span>{{result}}</span>&nbsp;
            </template>
            <template v-if="sum">
                = {{sum}}
            </template>
        </span>
    </span>
</template>

<script>
import DiceCommand from "../../services/commands/DiceCommand";

export default {
    props: {
        message: {
            required: true,
        }
    },

    data() {
        return {
            diceTypesArray: ['4', '6', '8', '10', '12', '20', '100'],
            resultsArray: [],
            messageDiceSizes: [],
            sum: 0
        }
    },

    mounted() {
        let commandBody = DiceCommand.getCommandBody(this.message.command);
        this.messageDiceSizes = DiceCommand.getDiceSizes(commandBody);

        this.resultsArray = this.message.text.split(' ');
        if (this.resultsArray.length > 1) {
            this.resultsArray.forEach((item) => {
                this.sum += parseInt(item);
            });
        }
    },

    methods: {
        generateSvgIcon(resultIndex)
        {
            if (typeof this.messageDiceSizes[resultIndex] === 'undefined') {
                return `#ic_dice100`;
            }

            let diceSize = this.messageDiceSizes[resultIndex];

            if (this.diceTypesArray.includes(diceSize)) {
                return `#ic_dice${diceSize}`
            }

            return `#ic_dice100`;
        }
    }

}
</script>

<style scoped>
</style>
